import React from "react";
import logo from "../../assets/images/ConnectHealthPro.png"

const Footer = () => (
  <footer>
    <div className="content space-between flex-v-center">
      <div className="footer-inner-left">
        <p>Terms of Service | Privacy Policy. | Copyright © {new Date().getFullYear()} ConnectHealthPro All rights reserved.</p>
      </div>
      <div className="footer-inner-right">
        <img height={50} src={logo} alt="" srcset="" />
      </div>
    </div>
  </footer>
);

export default Footer;
